// const PENGUINE = 'https://clean-penguin-constantly.ngrok-free.app'
// const SMASHING = 'https://520f-103-47-44-79.ngrok-free.app'
// const MAJOR = 'https://major-times-wonder.loca.lt'
// const onrender = `https://catchthattruck.onrender.com`;
// const trulyThankful = `https://truly-thankful-marten.ngrok-free.app`;
// const newURL = "https://catch-that-truck.uc.r.appspot.com";
// const newURL = "https://stagging-dot-catch-that-truck.uc.r.appspot.com";
const newURL = "https://api.catch-a-truck.booster-testing.com";

const GlobalURL = newURL;
export default GlobalURL;
